import React from 'react';
import logo from '../../assets/images/logo/logo.png';

const Logo = (props) => {
  return (
    <>
     <img src={logo} alt={props.alt} className={`mb-4 ${props.class}`}></img>
    </>
  )
}

export default Logo
